

<div id="">
   <header id="banner" role="banner">
      <nav class="site-breadcrumbs" id="breadcrumbs">
         <!--<h1> <span>Elementi Navigazione</span> </h1>--> 
         <ul class="breadcrumbs breadcrumbs-horizontal lfr-component">
            <li class="first"><span><a routerLink="">SIRA</a></span></li>
            <li><span><a href="/sirang/miinteressa">AREE TEMATICHE</a></span></li>
            <li class="last"><span><a href="/sirang/rifiuti">RIFIUTI</a></span></li>
         </ul>
      </nav>
   </header>
   <div id="content">
      <div class="portlet-boundary portlet-boundary_103_ portlet-static portlet-static-end " id="p_p_id_103_">
         <span id="p_103"></span> 
         <div class="portlet-body"> </div>
      </div>
      <div class="columns-2" id="main-content" role="main">
         <div class="portlet-layout">
            <div class="aui-w70 portlet-column" id="column-1">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-first" id="layout-column_column-1">
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_LbdzmfJsjuT2_">
                     <span id="p_56_INSTANCE_LbdzmfJsjuT2"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_LbdzmfJsjuT2">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text portlet-title-editable" style="margin-left: 0px;">Rifiuti e flussi di materiali</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
                                    <div class="journal-content-article">
                                       <p> Il modulo dedicato all'area tematica dei rifiuti ha lo scopo di supportare le attività della Sezione Regionale del Catasto Rifiuti e di tutti gli enti coinvolti nella gestione del ciclo dei rifiuti. Consente di inserire e modificare tutti i dati delle diverse tipologie di impianti (discariche, inceneritori etc.) e di gestire anche la loro evoluzione nel tempo, in modo da tenere traccia nel sistema delle modifiche delle caratteristiche tecniche e/o amministrative di ogni impianto. Il modulo Rifiuti ha inoltre lo scopo di rendere consultabili i dati quantitativi e qualitativi dei rifiuti prodotti, recuperati, smaltiti o tras-portati riportati nel Modello Unico di Dichiarazione in materia ambi-entale (MUD) e supporta, attraverso la sezione Osservatorio dei rifiuti urbani, l'elaborazione dei dati sui rifiuti. Il modulo gestisce anche le dichiarazioni di detenzione di apparecchi contenenti PCB, che, come già descritto nel paragrafo dedicato ai servizi offerti alle imprese, consente ai soggetti detentori di accedere al sistema, via web, per inserire i propri dati.</p>
                                       <p> Nell'ambito di quest'area tematica, per creare un ambiente omogeneo, funzionale e perfettamente integrato, si rende necessaria la progettazione e la realizzazione di diversi moduli applicativi che di seguito vengono riassunti;</p>
                                       <ul>
                                          <li> &nbsp;"Impianti Gestione Rifiuti e Apparecchi PCB" comprendente i catasti relativi ai diversi "tipi" di impianti gestione rifiuti e ai detentori di apparecchi PCB con relativa sezione specifica dedicata alle Dichiarazioni detentori apparecchi PCB</li>
                                          <li> &nbsp;"MUD" comprendente la relativa sezione dichiarazione, e la sezione specifica corredata da algoritmi che consentono la "bonifica" dei dati relativi ai MUD caricati nel database della DSA</li>
                                          <li> &nbsp;"SISTRI" Modulo gestione dati SISTRI, la cui fonte è un sistema informativo esterno al SIRA, deve garantire la consultazione e la navigazione tra i dati ricavati dal SISTRI allo scopo di poter effettuare riscontri e verifiche sulla movimentazione rifiuti</li>
                                          <li> "Osservatorio Rifiuti Urbani" Comprendente la relativa sezione dedicata alla raccolta/catalogazione dei dati sulla produzione e gestione dei rifiuti urbani dei Comuni, in base ai quali gli Osservatori Regionali e Provinciali possono effettuare le opportune verifiche, controlli, e predisporre la redazione di piani/programmi regionali di gestione e di smaltimento dei rifiuti urbani.</li>
                                       </ul>
                                       <p style="margin-left:14.2pt;"> &nbsp;</p>
                                    </div>
                                    <div class="entry-links"> </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
               </div>
            </div>
            <div class="aui-w30 portlet-column portlet-column-last" id="column-2">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-last" id="layout-column_column-2">
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_ieAw63KB7TJL_">
                     <span id="p_56_INSTANCE_ieAw63KB7TJL"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_ieAw63KB7TJL">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text" style="margin-left: 0px;">Dati ambientali</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
                                    <div class="journal-content-article">
                                       <ul>
                                          <li> <a target="_blank" href="https://portal.sardegnasira.it/web/sardegnaambiente/gestione-rifiuti-dati-ambientali">Vai alla pagina</a></li>
                                       </ul>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
               </div>
            </div>

         </div>
      </div>
      <form action="#" id="hrefFm" method="post" name="hrefFm"> <span></span> </form>
   </div>
</div>